<template>
    <b-container>
        <Breadcrumbs crumbString="FTP Uploads"></Breadcrumbs>
        <b-row><b-col><h2>{{ title }}</h2></b-col></b-row>
        <b-row>
          <b-col>
            <h4>Instructions for Uploading Files:</h4>
            <p>
              <strong>NOTE:</strong> <em>BE SURE THAT YOUR FILES ARE ZIPPED, THAT YOUR FILE NAME CORRESPONDS WITH YOUR PROJECT NAME AND/OR PROJECT NUMBER, AND
              NOTIFY YOUR PROJECT MANAGER OR SALES REP WHEN YOUR UPLOAD IS COMPLETE.</em>
            </p>
            <ul>
              <li>You can use a native file browser or you favorite FTP program, such as FileZilla or Cyberduck.</li>
              <li>After connected to the FTP you can drag and drop your files to upload them.</li>
              <li>We will provide you with the password to connect.</li>
            </ul>
            </b-col>
        </b-row>
      <b-row>
        <b-col col="6">
          <h4>Mac users:</h4>
          <ol>
            <li>Open Finder</li>
            <li>Click Go -> Connect to Server</li>
            <li>Enter <a href="ftp://ftp.igsigns.dynu.net" target="_blank"><strong>ftp://ftp.igsigns.dynu.net</strong></a> into the address bar</li>
            <li>Enter the username and password</li>
          </ol>
          <b-row>
            <b-col col="6">
              <img alt="enviroSIGNS" src="../../assets/images/ftp/mac-01.png"/>
            </b-col>
            <b-col col="6"></b-col>
          </b-row>
          <img alt="enviroSIGNS" src="../../assets/images/ftp/mac-02.png" style="padding: 5px 0;"/>
          <img alt="enviroSIGNS" src="../../assets/images/ftp/mac-03.png"/>
        </b-col>
        <b-col col="6">
          <h4>Windows users:</h4>
          <ol>
            <li>Open Windows Explorer</li>
            <li>Enter <a href="ftp://ftp.igsigns.dynu.net" target="_blank"><strong>ftp://ftp.igsigns.dynu.net</strong></a> into the address bar</li>
            <li>Enter the username and password</li>
          </ol>
          <img alt="enviroSIGNS" src="../../assets/images/ftp/windows-01.png" style="padding: 5px 0;"/>
          <img alt="enviroSIGNS" src="../../assets/images/ftp/windows-02.png"/>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
  import Breadcrumbs from '../Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'FTP Uploads'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/FtpUploads.vue